import React, {Component} from "react";
import {connect} from "react-redux";
import * as R from "ramda";
import {StatsDisplay} from "../CharacterSummary";
import {getGrade, getItem, getSlot} from "./ItemSmall";
import './ItemInfo.less'
import * as PropTypes from "prop-types";

export const colors = {
  cyan: '#40e0d0',
  gold: '#ffcc00',
  green: '#52e152',
  orange: '#ff8c00',
  yellow: '#ffff00',
};

class ComparisonInfo extends Component {
  static infoRef = React.createRef();

  calculatePosition = () => {
    const {position: {x: posX = 0, y: posY = 0} = {}} = this.props;
    const width = (_ItemInfo.infoRef.current || {}).clientWidth || 0;
    const height = (_ItemInfo.infoRef.current || {}).clientHeight || 0;
    const compareWidth = (ComparisonInfo.infoRef.current || {}).clientWidth || 0;
    const screenWidth = window.innerWidth;
    let {x, y} = {
      x: posX - 4 - compareWidth - 5,
      y: posY - 8 - height,
    };
    if ((posX - 4 + width) > screenWidth) x = posX - 8 - width - compareWidth - 5;
    if ((posY - 8 - height) < 0) {
      if ((posX - 4 + width) <= screenWidth) x = x + 16;
      y = posY + 16;
    }
    return {x, y};
  };

  render() {
    const {item: name, equipped, visible} = this.props;
    const {x, y} = this.calculatePosition();
    const item = getItem(equipped);
    if (!item) return null;
    const color = `#${item.color}`;
    const grade = getGrade(item.grade);
    return <div style={{visibility: (visible && (name !== equipped)) ? 'visible' : 'hidden'}}>
      <div className='item-info-equipped' style={{top: y - 19, left: x + 9}}>
        <div><div><div>Currently Equipped</div></div></div>
      </div>
      <div className='item-info' style={{top: y, left: x}} ref={ComparisonInfo.infoRef}>
      <div><div><div><div>
        <div style={{marginBottom: 8, color}}>{item.name}</div>
        <div style={{color}}>{item.rank}</div>
        <div>- {item.grade === 0 ? item.type : <><span style={{color: grade.color}}>{grade.name}</span> Grade {item.type}</>} -</div>
        <div style={{marginBottom: 0, color: colors.gold}}>{item.description}</div>
        {item.stats && <StatsDisplay stats={item.stats} colored/>}
        {item.level && <div style={{marginBottom: 0, marginLeft: 5, color: colors.yellow}}>Level {item.level}</div>}
      </div></div></div></div>
    </div>
    </div>;
  }
}

class _ItemInfo extends Component {
  static infoRef = React.createRef();

  calculatePosition = () => {
    const {position: {x: posX = 0, y: posY = 0} = {}} = this.props;
    const width = (_ItemInfo.infoRef.current || {}).clientWidth || 0;
    const height = (_ItemInfo.infoRef.current || {}).clientHeight || 0;
    const screenWidth = window.innerWidth;
    let {x, y} = {
      x: posX - 4,
      y: posY - 8 - height,
    };
    if ((posX - 4 + width) > screenWidth) x = posX - 8 - width;
    if ((posY - 8 - height) < 0) {
      if ((posX - 4 + width) <= screenWidth) x = x + 16;
      y = posY + 16;
    }
    return {x, y};
  };

  render() {
    const {item: name, visible} = this.props;
    const {x, y} = this.calculatePosition();
    const item = getItem(name);
    if (!item) return null;
    const color = `#${item.color}`;
    const grade = getGrade(item.grade);
    const visibility = visible ? 'visible' : 'hidden';
    return <div className='item-info' style={{top: y, left: x, visibility}} ref={_ItemInfo.infoRef}>
      <div><div><div><div>
        <div style={{marginBottom: 8, color}}>{item.name}</div>
        <div style={{color}}>{item.rank}</div>
        <div>- {item.grade === 0 ? item.type : <><span style={{color: grade.color}}>{grade.name}</span> Grade {item.type}</>} -</div>
        <div style={{marginBottom: 0, color: colors.gold}}>{item.description}</div>
        {item.stats && <StatsDisplay stats={item.stats} colored/>}
        {item.level && <div style={{marginBottom: 0, marginLeft: 5, color: colors.yellow}}>Level {item.level}</div>}
      </div></div></div></div>
    </div>;
  }
}

const InfoContainer = props => <>
  <ComparisonInfo {...props}/>
  <_ItemInfo {...props}/>
</>;

export const ItemInfo = connect(
  (state, props) => {
    let {visible = null, position = null} = R.path(['hint'])(state) || {};
    let item = state.hint.item || null;
    let equipped = item ? state.equipped[getSlot(item)] : null;
    return {item, equipped, visible, position};
  },
  (dispatch, props) => null,
)(InfoContainer);
